import React, { createContext, useContext } from 'react';
import { useProducts as useProductsHook } from '../hooks/useProducts';

// إنشاء الـ Context
const ProductsContext = createContext(null);

// الـ Provider
export const ProductsProvider = ({ children }) => {
    const hookData = useProductsHook();

    return (
        <ProductsContext.Provider
            value={{
                productsdata: hookData.products,
                loading: hookData.isLoading,
                error: hookData.error,
                refetchProducts: hookData.refetch,
                getProductById: hookData.getProductById,
                addProduct: hookData.addProduct,
                updateProduct: hookData.updateProduct,
                deleteProduct: hookData.deleteProduct,
                addComment: hookData.addComment,
                deleteComment: hookData.deleteComment,
                isAdding: hookData.isAdding,
                isUpdating: hookData.isUpdating,
                isDeleting: hookData.isDeleting,
            }}
        >
            {children}
        </ProductsContext.Provider>
    );
};

// الـ Hook المخصص
export const useProducts = () => {
    const context = useContext(ProductsContext);
    if (!context) {
        throw new Error('useProducts must be used within a ProductsProvider');
    }
    return context;
};